import React, { useState } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
/**
 * How to create Context API.
 * 1) Create a context using createContext() method.
 * 2) Provide context value at a hign-level in component tree.
 * 3) Consume the context value using the render props pattern.
 */

const themeDefault = createMuiTheme({
  palette: {
    primary: {
      light: '#4383cc',
      main: '#1565c0',
      dark: '#0e4686',
      contrastText: '#fff',
    },
  },
});

// 1) Create a context using createContext() method.
const MuiThemeContext = React.createContext();

// 2) Provide context value at a hign-level in component tree.
function MuiThemeProvider({ children }) {

  const [theme, setTheme] = useState(themeDefault);

  const setMuiTheme = (muiTheme) => {
    setTheme({ ...muiTheme });
  };

  return (
    <MuiThemeContext.Provider value={setMuiTheme}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </MuiThemeContext.Provider>
  );
}

const useMuiThemeContext = () => {
  return React.useContext(MuiThemeContext);
};

// Export SystemProvider, SystemConsumer & useSystemContext
export { MuiThemeProvider, useMuiThemeContext };
